module.exports = __webpack_public_path__ + "img/pdf_icon.de2a8ef5.png";